import { ValidatePromotionCodeResponse } from './../promotion-code/model/promotion-code.model';
import { OccupancyInfoDTO } from './../../model/checkout/guest-info.model';
import { TaxInfoModel } from './../../model/checkout/tax-info-model';
import { CheckOut3DataType, CompanyFeatureConfigType, RequestType } from './../../model/constant';
import { CheckOut3SubmitData } from './../../model/checkout/checkout3-config.model';
import { UserService } from './../user/user.service';
import { AuthenticationService } from './../authentication/authentication.service';
import { FeatureInternalOrderType, FeatureType, PurposeType, Page } from '../../model/constant';
import { GuestDetailsDto, GuestInfoModel, RoomModel, GuestInfo, GuestInfoV2 } from '../../model/checkout/guest-info.model';

import { ActHttpService, HeaderTypes } from '../act-http/act-http.service';
import { AppConfigService } from 'app/services/app-config/app-config.service';
import { BookerInfoModel } from '../../model/checkout/booker-info.model';
import { CartAndProfileModel } from '../../model/checkout/cart-profile.model';
import { ConditionModel } from '../../model/checkout/cart-option-detail-model';
import { CostCenterAddressModel } from 'app/model/checkout/cost-center-address.model';
import { CreateOrderPayload, CreateOrderPayloadWithPromotion, BookerPaymentCreditTerms, TaxAddress, BookerPaymentCreditCard, BookerTrueMoney, PaymentFleetCard, BookerPaymentQRCode, BookerPaymentEWallet, BookerPaymentIMBanking, BookerPaymentPayAtCounter } from './payload/create-order.payload';
import { Injectable } from '@angular/core';
import { InternalOrderFeature } from 'app/model/feature/internal-order-feature.model';
import { Observable } from 'rxjs/Observable';
import { ProductService } from 'app/services/products/product.service';
import { Response } from '@angular/http';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { UtilitiesService } from 'app/services/utilities/utilities.service';
import { environment } from '../../../environments/environment';
import store from 'store';
import { Condition, ConditionDisplay, ConditionDetail } from '../../model/condition/condition.model';
import { TranslateSingularPluralPipe } from 'app/pipes/translate-singular-plural.pipe';
import { BehaviorSubject, Subject } from 'rxjs';
import { AuthorizeService } from '../authorize/authorize.service';
import { FeatureModel } from 'app/model/user.model';
import { ValidateTravellerBudgetRequest, ValidateTravellerBudgetResponse } from 'app/model/checkout/validate-budget.model';
import { Checkout3Component } from 'app/pages/checkout-module/checkout3/checkout3.component';
import { PromotionCodeResponse } from '../promotion-code/model/promotion-code.model';
import { PromotionCodeService } from '../promotion-code/promotion-code.service';
import { InvalidPromotionCodeReason } from '../promotion-code/enum/promotion-code.enum';
// store.addPlugin(expirePlugin);

@Injectable()
export class CheckoutService {

  private mainBookerEmail$ = new Subject<string>();
  private currentStep: number;

  private fullNameSource = new BehaviorSubject('');
  currentFullName = this.fullNameSource.asObservable();

  private countryISO2Source = new BehaviorSubject('');
  currentCountryISO2 = this.countryISO2Source.asObservable();

  private mobileNumberSource = new BehaviorSubject('');
  currentMobileNumber = this.mobileNumberSource.asObservable();

  private isLoadingUploadDocumentSource = new BehaviorSubject(false);
  currentIsLoadingUploadDocument = this.isLoadingUploadDocumentSource.asObservable();

  private promoCode = new BehaviorSubject<PromotionCodeResponse | undefined>(undefined);
  public currentPromoCode = this.promoCode.asObservable();

  private validatedPromoCode = new BehaviorSubject<ValidatePromotionCodeResponse | undefined>(undefined);
  public currentValidatedPromoCode = this.validatedPromoCode.asObservable();

  private isLockedPromoCode = new BehaviorSubject<boolean>(false);
  public currentIsLockedPromoCode = this.isLockedPromoCode.asObservable();

  private grandTotalPrice = new BehaviorSubject<number>(null);
  public currentGrandTotalPrice = this.grandTotalPrice.asObservable();

  changeFullName(fullName: string) {
    this.fullNameSource.next(fullName);
  }
  changeCountryISO2(countryISO2: string) {
    this.countryISO2Source.next(countryISO2);
  }
  changeMobileNumber(mobileNumber: string) {
    this.mobileNumberSource.next(mobileNumber);
  }
  changeIsLoadingUploadDocument(isLoading: boolean) {
    this.isLoadingUploadDocumentSource.next(isLoading);
  }

  constructor(
    private actHttp: ActHttpService,
    private appConfigService: AppConfigService,
    private utilitiesService: UtilitiesService,
    private translate: TranslatePipe,
    private translatePlural: TranslateSingularPluralPipe,
    private productService: ProductService,
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private authorizeService: AuthorizeService,
    private authService: AuthenticationService,
  ) { }

  transformProfileDetailToBookerInfo(cartAndProfile: CartAndProfileModel): BookerInfoModel {
    const bookerInfo = new BookerInfoModel();
    bookerInfo.userId = cartAndProfile.user.userId;
    bookerInfo.visitorId = cartAndProfile.user.userId;
    bookerInfo.memberId = cartAndProfile.user.userId;
    bookerInfo.companyId = cartAndProfile.user.companyId;
    bookerInfo.email = cartAndProfile.user.username ? cartAndProfile.user.username.toLowerCase() : '';
    bookerInfo.typeOfTravelObjective = cartAndProfile.cart.purpose === 'work' ? 1 : 2;

    bookerInfo.fullName = cartAndProfile.user.fullName ? cartAndProfile.user.fullName : '';
    bookerInfo.mobileNumber = cartAndProfile.user.telephone ? cartAndProfile.user.telephone : '';
    bookerInfo.countryCallingCode = cartAndProfile.profile.countryCallingCode ? cartAndProfile.profile.countryCallingCode as string : '';

    return bookerInfo;
  }

  transformPromotionProfileDetailToBookerInfo(cartAndProfile: CartAndProfileModel): BookerInfoModel {
    const bookerInfo = new BookerInfoModel();
    bookerInfo.userId = cartAndProfile.user.userId;
    bookerInfo.visitorId = cartAndProfile.user.userId;
    bookerInfo.memberId = cartAndProfile.user.userId;
    bookerInfo.companyId = cartAndProfile.user.companyId;
    bookerInfo.typeOfTravelObjective = 2;

    return bookerInfo;
  }

  buildCreateOrderPayload(checkout2Data: CreateOrderPayload, checkout3Data: CheckOut3SubmitData[], checkout3: Checkout3Component): CreateOrderPayload {
    const createOrderPayload = new CreateOrderPayload();
    createOrderPayload.arrivalTime = checkout2Data.arrivalTime;
    createOrderPayload.bookerInfo = checkout2Data.bookerInfo;
    if (checkout2Data.isBookForTraveller) {
      createOrderPayload.guestInfo = this.clearAdditionalBookerTravellerInfo(checkout2Data.guestsBookerTravellerInfo);
    } else {
      createOrderPayload.guestInfo = this.clearSavingGuestInfo(checkout2Data.guestInfo);
    }
    checkout3Data.forEach(item => {
      const booker = createOrderPayload.getBookerByEmail(item.bookerEmail);
      switch (item.checkOutComponentData) {
        case CheckOut3DataType.CREDIT_TERMS_INFO:
          !booker.paymentCreditTerms && (booker.paymentCreditTerms = new BookerPaymentCreditTerms());
          booker.paymentCreditTerms.attachmentPath = item.data.attachmentPath;
          booker.paymentCreditTerms.ch3CustomFields = item.data.data;
          break;
        case CheckOut3DataType.CREDIT_TERMS_TAX_INFO:
          const creditTermsTaxData: TaxInfoModel = item.data;
          !booker.paymentCreditTerms && (booker.paymentCreditTerms = new BookerPaymentCreditTerms());
          booker.paymentCreditTerms.taxAddress = new TaxAddress();
          booker.paymentCreditTerms.taxAddress.taxAddress = creditTermsTaxData.address.valueOf();
          booker.paymentCreditTerms.taxAddress.taxName = creditTermsTaxData.company.valueOf();
          booker.paymentCreditTerms.taxAddress.taxId = creditTermsTaxData.number.valueOf();
          break;
        case CheckOut3DataType.CREDIT_CARD_INFO:
          !booker.paymentCreditCard && (booker.paymentCreditCard = new BookerPaymentCreditCard());
          booker.paymentCreditCard = { ...booker.paymentCreditCard, ...item.data };
          break;
        case CheckOut3DataType.CREDIT_CARD_TAX_INFO:
          !booker.paymentCreditCard && (booker.paymentCreditCard = new BookerPaymentCreditCard());
          booker.paymentCreditCard.taxAddress = new TaxAddress();
          booker.paymentCreditCard.taxAddress.taxAddress = item.data.address;
          booker.paymentCreditCard.taxAddress.taxName = item.data.title;
          booker.paymentCreditCard.taxAddress.taxId = item.data.taxNumber;
          break;
        case CheckOut3DataType.TRUE_MONEY_WALLET:
          !booker.paymentTrueMoney && (booker.paymentTrueMoney = new BookerTrueMoney());
          booker.paymentTrueMoney.accountNumber = item.data.accountNumber;
          booker.paymentTrueMoney.gatewayId = item.data.gatewayId;
          break;
        case CheckOut3DataType.TRUE_MONEY_WALLET_TAX_INFO:
          !booker.paymentTrueMoney && (booker.paymentTrueMoney = new BookerTrueMoney());
          booker.paymentTrueMoney.taxAddress = new TaxAddress();
          booker.paymentTrueMoney.taxAddress.taxAddress = item.data.address;
          booker.paymentTrueMoney.taxAddress.taxName = item.data.title;
          booker.paymentTrueMoney.taxAddress.taxId = item.data.taxNumber;
          break;
        case CheckOut3DataType.QR_CODE:
          !booker.paymentQRCode && (booker.paymentQRCode = new BookerPaymentQRCode());
          booker.paymentQRCode.gatewayId = item.data.gatewayId;
          break;
        case CheckOut3DataType.QR_CODE_TAX_INFO:
          !booker.paymentQRCode && (booker.paymentQRCode = new BookerPaymentQRCode());
          booker.paymentQRCode.taxAddress = new TaxAddress();
          booker.paymentQRCode.taxAddress.taxAddress = item.data.address;
          booker.paymentQRCode.taxAddress.taxName = item.data.title;
          booker.paymentQRCode.taxAddress.taxId = item.data.taxNumber;
          break;
        case CheckOut3DataType.E_WALLET:
          !booker.paymentEWallet && (booker.paymentEWallet = new BookerPaymentEWallet());
          booker.paymentEWallet.gatewayId = item.data.gatewayId;
          break;
        case CheckOut3DataType.E_WALLET_TAX_INFO:
          !booker.paymentEWallet && (booker.paymentEWallet = new BookerPaymentEWallet());
          booker.paymentEWallet.taxAddress = new TaxAddress();
          booker.paymentEWallet.taxAddress.taxAddress = item.data.address;
          booker.paymentEWallet.taxAddress.taxName = item.data.title;
          booker.paymentEWallet.taxAddress.taxId = item.data.taxNumber;
          break;
        case CheckOut3DataType.IM_BANKING:
          !booker.paymentIMBanking && (booker.paymentIMBanking = new BookerPaymentIMBanking());
          booker.paymentIMBanking.gatewayId = item.data.gatewayId;
          break;
        case CheckOut3DataType.IM_BANKING_TAX_INFO:
          !booker.paymentIMBanking && (booker.paymentIMBanking = new BookerPaymentIMBanking());
          booker.paymentIMBanking.taxAddress = new TaxAddress();
          booker.paymentIMBanking.taxAddress.taxAddress = item.data.address;
          booker.paymentIMBanking.taxAddress.taxName = item.data.title;
          booker.paymentIMBanking.taxAddress.taxId = item.data.taxNumber;
          break;
        case CheckOut3DataType.PAY_AT_COUNTER:
          !booker.paymentPayAtCounter && (booker.paymentPayAtCounter = new BookerPaymentPayAtCounter());
          booker.paymentPayAtCounter.gatewayId = item.data.gatewayId;
          break;
        case CheckOut3DataType.PAY_AT_COUNTER_TAX_INFO:
          !booker.paymentPayAtCounter && (booker.paymentPayAtCounter = new BookerPaymentPayAtCounter());
          booker.paymentPayAtCounter.taxAddress = new TaxAddress();
          booker.paymentPayAtCounter.taxAddress.taxAddress = item.data.address;
          booker.paymentPayAtCounter.taxAddress.taxName = item.data.title;
          booker.paymentPayAtCounter.taxAddress.taxId = item.data.taxNumber;
          break;
      }
    });
    checkout3Data
      .filter(item => item.checkOutComponentData === CheckOut3DataType.PAYMENT_INFO)
      .forEach((item, index) => {
        const booker = createOrderPayload.getBookerByEmail(item.bookerEmail);
        if (booker && booker.paymentCreditCard && item.data.creditCardAmount) {
          booker.paymentCreditCard.totalAmount = item.data.creditCardAmount;
        }
        if (booker && booker.paymentTrueMoney && item.data.trueMoneyAmount) {
          booker.paymentTrueMoney.totalAmount = item.data.trueMoneyAmount;
        }
        if (booker && booker.paymentQRCode && item.data.qrCodeAmount) {
          booker.paymentQRCode.totalAmount = item.data.qrCodeAmount;
        }
        if (booker && booker.paymentEWallet && item.data.eWalletAmount) {
          booker.paymentEWallet.totalAmount = item.data.eWalletAmount;
        }
        if (booker && booker.paymentIMBanking && item.data.imBankingAmount) {
          booker.paymentIMBanking.totalAmount = item.data.imBankingAmount;
        }
        if (booker && booker.paymentPayAtCounter && item.data.payAtCounterAmount) {
          booker.paymentPayAtCounter.totalAmount = item.data.payAtCounterAmount;
        }

        if (booker && booker.paymentCreditTerms && item.data.creditTermsAmount) {
          booker.paymentCreditTerms.totalAmount = index === 0 ? item.data.creditTermsAmount.booker : item.data.creditTermsAmount.coBooker;
        }
        if (booker && index === 0 && item.data.paymentPersonalFleetCard && item.data.paymentPersonalFleetCard.fleetCardId && item.data.paymentPersonalFleetCard.totalAmount) {
          booker.paymentPersonalFleetCard = new PaymentFleetCard(item.data.paymentPersonalFleetCard.fleetCardId, item.data.paymentPersonalFleetCard.totalAmount);
        }
        if (booker && index === 0 && item.data.paymentCorporateFleetCard && item.data.paymentCorporateFleetCard.fleetCardId && item.data.paymentCorporateFleetCard.totalAmount) {
          booker.paymentCorporateFleetCard = new PaymentFleetCard(item.data.paymentCorporateFleetCard.fleetCardId, item.data.paymentCorporateFleetCard.totalAmount);
        }
      });

    if (checkout3.useBookForTraveller(checkout2Data.isBookForTraveller)) {
      createOrderPayload.isBookForTraveller = true;
      let totalPaymentCreditTerms = 0;
      createOrderPayload.bookerInfo.map(m => {
        m.paymentCreditTerms.totalAmount = m.totalCharge || 0;
        totalPaymentCreditTerms += m.totalCharge ? m.totalCharge : 0;
        delete m.totalCharge;
      });

      const { validateInfo } = this.getCurrentPromotionCode();
      if (validateInfo && validateInfo.valid) {
        let totalPaymentCreditTermsAfterDiscount = validateInfo.finalAmount;
        let totalDiscountToCreditTerms = 0;
        createOrderPayload.bookerInfo.map((m, index) => {
          if (index === 0) {
            totalPaymentCreditTermsAfterDiscount -= m.paymentCreditCard ? m.paymentCreditCard.totalAmount : 0;
            totalPaymentCreditTermsAfterDiscount -= m.paymentTrueMoney ? m.paymentTrueMoney.totalAmount : 0;
            totalPaymentCreditTermsAfterDiscount -= m.paymentPersonalFleetCard ? m.paymentPersonalFleetCard.totalAmount : 0;
            totalDiscountToCreditTerms = totalPaymentCreditTerms - totalPaymentCreditTermsAfterDiscount;
          }
          if (totalDiscountToCreditTerms > 0) {
            if (createOrderPayload.bookerInfo.length === index + 1) {
              m.paymentCreditTerms.totalAmount = m.paymentCreditTerms.totalAmount - totalDiscountToCreditTerms;
            } else {
              const newAmount = Math.floor(m.paymentCreditTerms.totalAmount * totalPaymentCreditTermsAfterDiscount / totalPaymentCreditTerms);
              totalDiscountToCreditTerms -= m.paymentCreditTerms.totalAmount - newAmount;
              m.paymentCreditTerms.totalAmount = newAmount;
            }
          }
        });
      }
    }
    // if (checkout3Data.paymentInfo.paymentMethod === PaymentMethodUpperCaseType.creditTerms) {
    //   createOrderPayload.taxAddress.taxId = checkout3Data.userBillingAddressId;
    //   createOrderPayload.internalOrder = checkout3Data.fundCode;
    //   createOrderPayload.attachment = checkout3Data.attachment;
    // }

    // if (checkout3Data.costCenter) {
    //   createOrderPayload.costCenter.costCenterCode = checkout3Data.costCenter.code;
    //   createOrderPayload.costCenter.costCenterName = checkout3Data.costCenter.name;
    // }

    // createOrderPayload.taxAddress = new OneTimeTaxAddress();
    // createOrderPayload.taxAddress.taxAddress = checkout3Data.taxInfo.address;
    // createOrderPayload.taxAddress.taxId = checkout3Data.taxInfo.number;
    // createOrderPayload.taxAddress.taxName = checkout3Data.taxInfo.company;

    return createOrderPayload;
  }

  buildCreateOrderPayloadWithPromotion(checkout2Data: CreateOrderPayloadWithPromotion, checkout3Data: any): CreateOrderPayloadWithPromotion {
    const createOrderPayload = new CreateOrderPayloadWithPromotion();
    createOrderPayload.bookerInfo = checkout2Data.bookerInfo;
    createOrderPayload.arrivalTime = checkout2Data.arrivalTime;
    let paymentCreditCard = new BookerPaymentCreditCard();
    checkout2Data.bookerInfo.map(booker => booker.paymentCreditCard = { ...checkout3Data });
    // TODO :: Uncomment when fix promition work with multi payment
    // delete createOrderPayload.bookerInfo.email;

    createOrderPayload.guestInfo = checkout2Data.guestInfo;
    // createOrderPayload.paymentInfo = checkout3Data.paymentInfo;
    // createOrderPayload.taxAddress = new OneTimeTaxAddress();
    // createOrderPayload.taxAddress.taxAddress = checkout3Data.taxInfo.address;
    // createOrderPayload.taxAddress.taxId = checkout3Data.taxInfo.number;
    // createOrderPayload.taxAddress.taxName = checkout3Data.taxInfo.company;
    return createOrderPayload;
  }

  transformCartInfoToGuestDetails(cartAndProfile: CartAndProfileModel): GuestDetailsDto[] {
    let index = 0;
    return cartAndProfile.cart.optionDetail.optionList.map(option =>
      option.conditionList.map(condition =>
        condition.quantity > 0 && Array.from(Array(condition.quantity.valueOf()).keys()).map(() => {
          const guestDetail = new GuestDetailsDto;
          guestDetail.room = new RoomModel();
          const adult = cartAndProfile.cart.optionDetail.roomOccupancy[index].adult;
          const child = cartAndProfile.cart.optionDetail.roomOccupancy[index].child;
          guestDetail.index = index + 1;
          guestDetail.room.title = this.productService.formatDisplayTitle(option.title);
          guestDetail.room.optionCode = condition.optionCode;
          guestDetail.room.adult = adult ? adult : 0;
          guestDetail.room.child = child ? child : 0;

          guestDetail.room.maxAdult = guestDetail.room.adult > 0 ? this.translatePlural.transform(`checkout-1-max-adult-title`, guestDetail.room.adult).replace(/{X}/gi, guestDetail.room.adult) : '';
          guestDetail.room.maxChild = guestDetail.room.child > 0 ? this.translatePlural.transform(`checkout-1-max-child-title`, guestDetail.room.child).replace(/{X}/gi, guestDetail.room.child) : '';
          guestDetail.room.allGuests = guestDetail.room.adult.valueOf() + guestDetail.room.child.valueOf();
          if (condition.selectedBedTypeEn && condition.selectedBedTypeTh) {
            guestDetail.room.selectedBedTypeEn = condition.selectedBedTypeEn;
            guestDetail.room.selectedBedTypeTh = condition.selectedBedTypeTh;
          }
          // Check feature of user
          const guestDefault = new GuestInfoModel();
          if (cartAndProfile.cart.approvalRequestId && cartAndProfile.preApprovalDetail && cartAndProfile.preApprovalDetail.requestType !== RequestType.BOOK_FOR_TRAVELLER) {
            const guest = cartAndProfile.preApprovalDetail.travellers[index];
            if (guest) {
              guestDefault.fullName = guest.fullName;
              guestDefault.email = guest.email;
              guestDefault.nationality = guest.nationality;
              if (guest.countryCallingCode && guest.phone) {
                guestDefault.countryCallingCode = guest.countryCallingCode;
                guestDefault.mobileNumber = guest.phone;
              }
            }
          } else {
            cartAndProfile.user.features && cartAndProfile.user.features.map(feature => {
              if (cartAndProfile.cart.purpose === PurposeType.work && feature.feature === FeatureType.ALLOW_LIMIT_ROOM && feature.allow) {
                guestDefault.fullName = cartAndProfile.profile.fullName;
                guestDefault.email = cartAndProfile.profile.email;
                guestDefault.nationalityId = 'TH';
              }
            });
          }
          index++;
          guestDetail.guestInfoList = [guestDefault];
          guestDetail.guestInfoBookerTravellerList = [guestDefault];
          return guestDetail;
        })
      ).reduce((a, b) => a.concat(b))
    ).reduce((a, b) => a.concat(b));
  }

  addGuestInformation(guests: GuestInfoModel[], maxGuest: number): GuestInfoModel[] {
    guests.length < maxGuest ? guests.push(new GuestInfoModel()) : '';
    return guests;
  }

  deleteGuestInformation(guests: GuestInfoModel[], index: number): GuestInfoModel[] {
    if (guests.length > 1 && index >= 0) {
      return guests.slice(0, index).concat(guests.slice(index + 1));
    }
    return guests;
  }

  clearSavingGuestInfo(guestInfo: GuestInfo[]) {
    guestInfo.forEach(gi => {
      gi.guests.forEach(guest => {
        delete guest.savingGuest;
      });
    });
    return guestInfo;
  }

  clearAdditionalBookerTravellerInfo(guestsBookerTravellerInfo: GuestInfo[]): GuestInfo[] {
    const guestInfo = [];
    guestsBookerTravellerInfo.forEach(bookerTravller => {
      const guestInfoV2 = [];
      bookerTravller.guests.map(guest => guestInfoV2.push(new GuestInfoV2(<GuestInfoModel>guest)));
      bookerTravller.guests = guestInfoV2;
      guestInfo.push(bookerTravller);
    });
    return guestInfo;
  }

  // ***************** HTTP Connection ************************************* //
  createOrder(payload: CreateOrderPayload): Observable<any> {
    return this.actHttp.post(
      environment.endpoint.createBooking,
      payload,
      this.actHttp.getRequestOptions(HeaderTypes.ACT_TOKEN, null)
    ).map((res: Response) => res.text());
  }

  createOrderWithPromotionCode(payload: CreateOrderPayload): Observable<any> {
    return this.actHttp.post(
      environment.endpoint.createBooking,
      payload,
      this.actHttp.getRequestOptions(HeaderTypes.ACT_TOKEN, null)
    ).map((res: Response) => res.text());
  }

  validateCreditCard(sixDigit: string): Observable<any> {
    return this.actHttp.get(
      `${environment.endpoint.validateCreditCart}${sixDigit}`,
      this.actHttp.getRequestOptions()
    ).map((res: Response) => res);
  }

  // ***************** Checkout Data in Local Storage ************************ //
  saveCheckoutData(cartAndProfile: CartAndProfileModel) {
    const data = this.utilitiesService.encodeToCookie(JSON.stringify(cartAndProfile));
    const expireTime = new Date().getTime() + 18e5; // expire time 30 minite
    store.set(AppConfigService.checkoutDataCookieName, data, expireTime);
  }

  getCheckoutData(): CartAndProfileModel {
    const dataEncode = store.get(AppConfigService.checkoutDataCookieName);
    const dataDecode = dataEncode ? this.utilitiesService.decodeFromCookie(dataEncode) : undefined;
    const data = dataDecode ? <CartAndProfileModel>JSON.parse(dataDecode) : undefined;
    return data;
  }

  clearCheckoutData() {
    store.remove(AppConfigService.checkoutDataCookieName);
    return true;
  }

  getPriceSelling(condition: ConditionModel): number {
    return Math.ceil(condition.totalPriceSellingFinalSupplierCurrency.valueOf());
  }

  getTextFeatureInternalOrder(type = FeatureInternalOrderType.label, internalOrderFeature: InternalOrderFeature): string {
    let defaultKey = ``;
    switch (type) {
      case FeatureInternalOrderType.label:
        defaultKey = `checkout-3-label-fund-code`;
        break;
      case FeatureInternalOrderType.placeholder:
        defaultKey = `checkout-3-placeholder-fund-code`;
        break;
      default:
        defaultKey = `checkout-3-label-fund-code`;
        break;
    }

    const lang = this.appConfigService.getLanguage();
    const data = internalOrderFeature ? internalOrderFeature[type] : null;

    return data && data[lang] ? data[lang] : this.translate.transform(defaultKey);
  }

  getTaxAddressByCostCenter(companyCode: String, costCenterCode: String): Observable<CostCenterAddressModel> {
    const langId = this.appConfigService.getLanguageId();
    const options = this.actHttp.getRequestOptions();
    const url = `${environment.endpoint.getTaxAddress
      .replace(':affiliate', companyCode && companyCode.valueOf())
      .replace(':costCenterCode', costCenterCode && costCenterCode.valueOf())}?langId=${langId}`;
    return this.actHttp.get(url, options).map((res: Response) => res.json().data);
  }



  transformStringToArray(data: string, type: string = '') {
    let temp: any;
    switch (type) {
      case 'column':
        temp = data.split(',');
        break;
      default:
        temp = data.split(',').map(res => res.split('=').slice(1));
        break;
    }
    return [].concat.apply([], temp);
  }
  transformDetailNodeToArray(condition: Condition) {
    const conditionDetail: string[][] = [];
    let index = 0;
    while (index < condition.details.length) {
      conditionDetail.push(this.transformDetailNode(condition.details[index]));
      index++;
    }
    return conditionDetail;
  }
  transformDetailNode(data: ConditionDetail) {
    const result: string[] = [];
    let values: string[];
    let title: string;
    values = this.transformStringToArray(data.details[0].message);
    //In case of HTB change text from 'ROOM' to 'Room'
    values[0] = this.formatDisplayTitle(values[0]);
    switch (data.code) {
      case '40711':
        result.push(values[0]);
        result.push(this.appConfigService.getTranslateWithLang('menu-bar-baht', 'en') + ' ' + this.setCurrencyFormat(values[1]));
        result.push(this.appConfigService.getTranslateWithLang('menu-bar-baht', 'en') + ' ' + this.setCurrencyFormat(values[2]));
        break;
      case '40721':
        result.push(values.shift());
        result.push(this.createListOfEachRoomType(data, 'condition-cancellation-policy-baht'));
        break;
      case '40722':
        result.push(values.shift());
        result.push(this.createListOfEachRoomType(data, 'condition-cancellation-policy-free-of-charge'));
        break;
      case '40723':
        title = this.appConfigService.getTranslate('condition-cancellation-policy-non-refundable');
        result.push(values[0]);
        result.push(title);
        break;
      case '40781':
        result.push(values[0]);
        result.push(this.appConfigService.getTranslate('condition-offer-type-breakfast-include'));
        result.push(this.appConfigService.getTranslate('condition-offer-type-breakfast-not-include'));
        break;
      default:
        break;
    }
    return result;
  }
  createListOfEachRoomType(data: ConditionDetail, keyLangTranslate: string) {
    let title: string, message = '', tempMessage: string;
    let values: any[];
    let index = 0;
    title = this.appConfigService.getTranslate(keyLangTranslate);
    while (index < data.details.length) {
      values = this.transformStringToArray(data.details[index].message);
      values.shift();
      if (data.details.length === 1) {
        message = '<li> ' + this.replaceValueInString(title, values) + '<\li>';
        break;
      }
      if (index === data.details.length - 1) {
        tempMessage = '<li> - ' + this.replaceValueInString(title, values) + '<\li>';
      } else {
        tempMessage = '<li> - ' + this.replaceValueInString(title, values) + '<\li> <br/>';
      }
      message += tempMessage;
      index++;
    }
    return message;
  }
  replaceValueInString(message: string, data: any[]) {
    data.forEach(res => {
      if (this.utilitiesService.checkDateformat(res, 'YYYY-MM-D')) {
        res = this.utilitiesService.getOtaFormatYear(this.appConfigService.getLanguage(), res, 'D MMM YYYY');
      }
      if (!isNaN(res)) {
        res = this.setCurrencyFormat(res);
      }
      message = message.replace('${var}', res);
    });
    return message;
  }
  popUpDataByCase(condition: Condition, routePageContinue: string) {
    const data = new ConditionDisplay();
    switch (condition.code) {
      case '4071':
        data.code = condition.code;
        data.imgPath = 'assets/images/icons/icon-pricechange.png';
        data.title = this.appConfigService.getTranslate('condition-selling-price-in-budget-title');
        data.columns = this.transformStringToArray(this.appConfigService.getTranslate('condition-selling-price-in-budget-column'), 'column');
        data.row = this.transformDetailNodeToArray(condition);
        data.btn.push(this.appConfigService.getTranslate('condition-button-back-to-search'));
        data.btn.push(this.appConfigService.getTranslate('condition-button-accept'));
        data.route = routePageContinue;
        break;
      case '4072':
        data.code = condition.code;
        data.imgPath = 'assets/images/icons/icon-cancellationchange.png';
        data.title = this.appConfigService.getTranslate('condition-cancellation-policy-title');
        data.columns = this.transformStringToArray(this.appConfigService.getTranslate('condition-cancellation-policy-column'), 'column');
        data.row = this.transformDetailNodeToArray(condition);
        data.btn.push(this.appConfigService.getTranslate('condition-button-back-to-search'));
        data.btn.push(this.appConfigService.getTranslate('condition-button-accept'));
        data.route = routePageContinue;
        break;
      case '4078':
        data.code = condition.code;
        data.imgPath = 'assets/images/icons/icon-breakfastchange.png';
        data.title = this.appConfigService.getTranslate('condition-offer-type-title');
        data.columns = this.transformStringToArray(this.appConfigService.getTranslate('condition-offer-type-column'), 'column');
        data.row = this.transformDetailNodeToArray(condition);
        data.btn.push(this.appConfigService.getTranslate('condition-button-back-to-search'));
        data.btn.push(this.appConfigService.getTranslate('condition-button-accept'));
        data.route = routePageContinue;
        break;
      case '4075':
        data.code = condition.code;
        data.imgPath = 'assets/images/icons/icon-paymentchange.png';
        data.title = this.appConfigService.getTranslate('condition-cancellation-policy-pay-now');
        data.title = this.replaceValueInString(data.title, this.transformStringToArray(condition.message));
        data.btn.push(this.appConfigService.getTranslate('condition-button-back-to-search'));
        data.btn.push(this.appConfigService.getTranslate('condition-button-accept'));
        data.route = routePageContinue;
        break;
      case '4076':
        data.code = condition.code;
        data.imgPath = 'assets/images/icons/icon-paymentchange.png';
        data.title = this.appConfigService.getTranslate('condition-cancellation-policy-pay-later');
        data.title = this.replaceValueInString(data.title, this.transformStringToArray(condition.message));
        data.btn.push(this.appConfigService.getTranslate('condition-button-back-to-search'));
        data.btn.push(this.appConfigService.getTranslate('condition-button-accept'));
        data.route = routePageContinue;
        break;
      case '4077':
        data.code = condition.code;
        data.imgPath = 'assets/images/icons/icon-paymentchange.png';
        data.title = this.appConfigService.getTranslate('condition-cancelltaion-policy-pay-later-from-to');
        data.title = this.replaceValueInString(data.title, this.transformStringToArray(condition.message));
        data.btn.push(this.appConfigService.getTranslate('condition-button-back-to-search'));
        data.btn.push(this.appConfigService.getTranslate('condition-button-accept'));
        data.route = routePageContinue;
        break;
      case '4081': case '4811': case '4807': case '4808':
        data.code = condition.code;
        data.imgPath = 'assets/images/icons/icon-budgetlimit.png';
        data.title = this.appConfigService.getTranslate('condition-selling-price-over-budget');
        data.btn.push(this.appConfigService.getTranslate('condition-button-back-to-search'));
        data.route = Page.REDIRECT;
        break;
      case '4082':
        data.code = condition.code;
        data.imgPath = 'assets/images/icons/icon-budgetlimit.png';
        data.title = this.appConfigService.getTranslate('condition-limit-room-title');
        data.title = this.replaceValueInString(data.title, [1]);
        data.btn.push(this.appConfigService.getTranslate('condition-button-back-to-search'));
        data.route = Page.HOME;
        break;
      case '4083':
        data.code = condition.code;
        data.imgPath = 'assets/images/icons/icon-worstcase.png';
        data.title = this.appConfigService.getTranslate('condition-no-available-room-title');
        data.btn.push(this.appConfigService.getTranslate('condition-button-back-to-search'));
        data.route = Page.REDIRECT;
        break;
      case '4701':
        if (condition.message === 'Share budget code not found') {
          data.code = condition.code;
          data.imgPath = 'assets/images/icons/icon-failed.png';
          data.title = this.appConfigService.getTranslate('checkout-3-error-cannot-create-booking');
          data.btn.push(this.appConfigService.getTranslate('btn-ok'));
          data.route = Page.LEVEL_D;
          this.authorizeService.removeCoBookerCookie();
        } else {
          data.code = condition.code;
          data.imgPath = 'assets/images/icons/icon-failed.png';
          data.title = this.appConfigService.getTranslate('checkout-3-error-credit-term-not-allow');
          data.btn.push(this.appConfigService.getTranslate('btn-ok'));
          data.route = null;
        }
        break;
      case '4711':
        data.code = condition.code;
        data.imgPath = 'assets/images/icons/icon-calendar.png';
        data.title = this.appConfigService.getTranslate('condition-period-overlaps-title');
        data.description = this.appConfigService.getTranslate(!this.authorizeService.getCoBookerCookie() ? 'condition-period-overlaps-description' : 'condition-period-overlaps-share-budget-description');
        data.btn.push(this.appConfigService.getTranslate('btn-ok'));
        data.route = Page.LEVEL_D;
        break;
      case '4717': case '4731':
        data.code = condition.code;
        data.imgPath = 'assets/images/icons/icon-failed.png';
        data.title = this.appConfigService.getTranslate('checkout-3-error-supervisor-email-invalid');
        data.btn.push(this.appConfigService.getTranslate('btn-ok'));
        data.route = null;
        break;
      case '4084':
        data.code = condition.code;
        data.imgPath = 'assets/images/icons/icon-calendar.png';
        data.title = this.appConfigService.getTranslate('productlists-pop-up-error-across-month');
        data.btn.push(this.appConfigService.getTranslate('btn-ok'));
        data.route = Page.HOME;
        break;
      case '4091':
        data.code = condition.code;
        data.imgPath = 'assets/images/icons/icon-failed.png';
        data.title = this.appConfigService.getTranslate('condition-restrict-destination-title');
        data.description = this.appConfigService.getTranslate('condition-restrict-destination-description');
        data.btn.push(this.appConfigService.getTranslate('btn-ok'));
        data.route = Page.LEVEL_D;
        break;
      case '4092':
        data.code = condition.code;
        data.imgPath = 'assets/images/icons/icon-failed.png';
        data.title = this.appConfigService.getTranslate('condition-restrict-destination-co-booker-title');
        data.description = this.appConfigService.getTranslate('condition-restrict-destination-co-booker-description');
        data.btn.push(this.appConfigService.getTranslate('btn-ok'));
        data.route = Page.LEVEL_D;
        break;
      case '4813':
        data.code = condition.code;
        data.imgPath = 'assets/images/icons/icon-failed.png';
        data.title = this.appConfigService.getTranslate('condition-some-guest-not-exist-in-your-comany');
        data.description = condition.message.match(/\[(.+)\]/)[1];
        data.btn.push(this.appConfigService.getTranslate('btn-ok'));
        data.route = null;
        break;
      case '4814':
        data.code = condition.code;
        data.imgPath = 'assets/images/icons/icon-failed.png';
        data.title = this.appConfigService.getTranslate('condition-some-guest-not-allow-to-use-credit-terms');
        data.description = condition.message.match(/\[(.+)\]/)[1];
        data.btn.push(this.appConfigService.getTranslate('btn-ok'));
        data.route = null;
        break;
      case '4815':
        data.code = condition.code;
        data.imgPath = 'assets/images/icons/icon-failed.png';
        data.title = this.appConfigService.getTranslate('condition-some-guest-already-have-a-booking-in-this-period');
        data.description = condition.message.match(/\[(.+)\]/)[1];
        data.btn.push(this.appConfigService.getTranslate('btn-ok'));
        data.route = null;
        break;
      case '4816':
        data.code = condition.code;
        data.imgPath = 'assets/images/icons/icon-failed.png';
        data.title = this.appConfigService.getTranslate('condition-some-guest-has-no-supervisor-email');
        data.description = condition.message.match(/\[(.+)\]/)[1];
        data.btn.push(this.appConfigService.getTranslate('btn-ok'));
        data.route = null;
        break;
      default:
        return null;
    }
    return data;
  }
  setCurrencyFormat(amount: string) {
    return this.utilitiesService.insertCurrencySymbol(Number(amount));
  }
  formatDisplayTitle(title: String): string {
    return title ? title.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()) : ``;
  }

  saveBudgetSuggestion(suggestionBudget: number): Observable<boolean> {
    const user = this.userService.getUser();
    const requestOption = this.authenticationService.getRequestOptions(HeaderTypes.ACT_TOKEN);
    const payload = {
      companyId: user.companyId,
      suggestionBudget: +suggestionBudget
    };
    return this.actHttp.post(
      environment.endpoint.setBudgetSuggestion,
      payload,
      requestOption)
      .map(() => true);
  }

  getMainBookerEmail() {
    return this.mainBookerEmail$.asObservable();
  }

  updateMainBookerEmail(data) {
    this.mainBookerEmail$.next(data);
  }

  getCheckoutConfigBooker(): Observable<FeatureModel[]> {
    const user = this.userService.getUser();
    const featureForcheckout3 = [
      FeatureType.ALLOW_CREDIT_TERMS,
      FeatureType.ALLOW_MULTI_PAYMENT,
      FeatureType.ALLOW_LIMIT_ROOM,
      FeatureType.ALLOW_LIMIT_BUDGET,
      FeatureType.ALLOW_CORPORATE_FLEET,
      FeatureType.ALLOW_MULTI_PAYMENT_CORPORATE_FLEET,
      FeatureType.ALLOW_BOOK_FOR_TRAVELLER,
      CompanyFeatureConfigType.CONFIG_CHECKOUT_3,
      FeatureType.ENABLE_PIN,
      FeatureType.ENABLE_PRE_APPROVAL,
    ];
    return this.authService.getUserFeature(null, user, featureForcheckout3);
  }

  getCheckoutConfigCoBooker(shareBudgetCode: string): Observable<FeatureModel[]> {
    const user = this.userService.getUser();
    const featureForcheckout3 = [
      FeatureType.ALLOW_CREDIT_TERMS,
      FeatureType.ALLOW_MULTI_PAYMENT,
      FeatureType.ALLOW_LIMIT_ROOM,
      FeatureType.ALLOW_LIMIT_BUDGET,
      CompanyFeatureConfigType.CONFIG_CHECKOUT_3
    ];
    return this.authService.getUserFeature(null, user, featureForcheckout3, false, shareBudgetCode);
  }

  validateTravellerBudget(request: ValidateTravellerBudgetRequest): Observable<ValidateTravellerBudgetResponse[]> {
    return this.actHttp.post(
      environment.endpoint.travellerBudget,
      request,
      this.actHttp.getRequestOptions(HeaderTypes.ACT_TOKEN)
    ).map((res: Response) => res.json().data);
  }

  updateCurrentStep(step) {
    this.currentStep = step;
  }

  getCurrentStep() {
    return this.currentStep;
  }

  transformOccupancyInfo(adult: number, child: number, childAges: number[]): OccupancyInfoDTO {
    let adultDisplay = this.translatePlural.transform(`checkout-1-adult-title`, adult).replace(/{X}/gi, adult);
    let childDisplay = '';
    let childAgesDisplay = '';
    if (child != 0) {
      childDisplay = this.translatePlural.transform(`checkout-1-child-title`, child).replace(/{X}/gi, child);
      if (childAges.length > 0) {
        childAgesDisplay = childAgesDisplay.concat(`${this.translate.transform(`checkout-1-ages`)}: `, '');
        childAges.forEach((age, index) => {
          if (index > 0) {
            childAgesDisplay = childAgesDisplay.concat(
              index === childAges.length - 1 ? ` ${this.translate.transform(`checkout-1-and`)} ` : `, `
            );
          }
          childAgesDisplay = childAgesDisplay.concat(`${age}`);
        });
        childAgesDisplay = childAgesDisplay.concat(this.translate.transform(`checkout-1-year`));
      }
    }
    return { adult: adultDisplay, child: childDisplay, childAges: childAgesDisplay };
  }

  updatePromotionCode(promoCode: PromotionCodeResponse) {
    this.promoCode.next(promoCode);
  }

  updateValidatedPromotionCode(validatedPromoCode: ValidatePromotionCodeResponse) {
    if (validatedPromoCode && !validatedPromoCode.valid) {
      const reason = validatedPromoCode.reason.toLowerCase();
      switch (reason) {
        case InvalidPromotionCodeReason.INVALID_PAYMENT_METHOD:
        case InvalidPromotionCodeReason.PAYMENT_ISSUER_NOT_ALLOWED:
          validatedPromoCode.reason = InvalidPromotionCodeReason.INVALID_PAYMENT_METHOD;
          break;
        case InvalidPromotionCodeReason.QUOTA_EXHAUSTED:
        case InvalidPromotionCodeReason.BUDGET_NOT_ENOUGH:
        case InvalidPromotionCodeReason.USAGE_LIMIT_EXCEEDED:
          validatedPromoCode.reason = 'reached_limit';
          break;
        default:
          validatedPromoCode.reason = InvalidPromotionCodeReason.CONDITION_NOT_MET;
      }
    }
    this.validatedPromoCode.next(validatedPromoCode);
  }

  updateIsLockedPromotionCode(isLocked: boolean) {
    this.isLockedPromoCode.next(isLocked);
  }

  getCurrentPromotionCode() {
    return {
      codeInfo: this.promoCode.value,
      validateInfo: this.validatedPromoCode.value
    };
  }

  updateGrandTotalPrice(grandTotalPrice: number) {
    this.grandTotalPrice.next(grandTotalPrice);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/checkout/checkout.service.ts